const validateHppMaxTrial = (days?: number) => {
  if (days === undefined || (0 <= days && days <= 90)) return undefined;
  return 'Hodnota musí být 0 až 90.';
};
export default validateHppMaxTrial;
